import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';


const propTypes = {
    component: PropTypes.func,
    isAuthenticated: PropTypes.bool,
    isProtected: PropTypes.bool,
};

const AppRoute = props => {
    return <Route {...props} />;
};

AppRoute.propTypes = propTypes;

export default AppRoute;
